module.exports = __webpack_public_path__ + "img/man-banner.8947b4f8.png";